import React, { useState } from 'react';
import { Form, Button, Accordion } from 'react-bootstrap';
import { FaCreditCard, FaApplePay, FaCcPaypal } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import { useLocation } from 'react-router-dom';
import PaymentSuccessModal from '../Models/PaymentSuccessModal';

const CheckoutPage = () => {
    const [paymentMethod, setPaymentMethod] = useState('card');
    const [activeKey, setActiveKey] = useState('0');
    const [country, setCountry] = useState('');
    const [zip, setZip] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expireDate, setExpireDate] = useState('');
    const [cvc, setCvc] = useState('');
    const [cardName, setCardName] = useState('');
    const [activeModal, setActiveModal] = useState(false);
    const location = useLocation();
    const featureName = location.state?.featureName;

    const handleSelect = (key, method) => {
        setActiveKey(key);
        setPaymentMethod(method);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    
        if (isFormValid()) {
            console.log("Selected payment method:", paymentMethod);
            setActiveModal(true);
        } else {
            alert('Please fill out all required fields.');
        }
    };
    
    // Function to check if all required fields are filled
    const isFormValid = () => {
        return country && zip && cardNumber && expireDate && cvc && cardName;
    };

    return (
        <div id="checkOut">
            <div className="checkOutWrapper">
                <h2 className="mb-3">Checkout</h2>
            </div>

            <div className="checkOutContainer">
                <div className="wrapper d-flex flex-column flex-md-row">
                    {/* LEFT SIDE */}
                    <div className="Details p-4">
                        <div className="headingOne mb-4">Details</div>
                        <div className="headingOne mb-4">Billing address & payment method</div>

                        <Form className="w-100" onSubmit={handleSubmit}>
                            <div className="mb-2">Billing address</div>
                            <div className="d-flex flex-column flex-md-row gap-3 mb-3">
                                <div className="w-100">
                                    <Form.Group controlId="country">
                                        <Form.Label>Country<span className="text-danger">*</span></Form.Label>
                                        <Form.Select required value={country} onChange={(e) => setCountry(e.target.value)}>
                                            <option value="">Select Country</option>
                                            <option>United States</option>
                                            <option>India</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="w-100">
                                    <Form.Group controlId="zip">
                                        <Form.Label>ZIP Code<span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="123456" value={zip} onChange={(e) => setZip(e.target.value)} required />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className=" mb-4">Tutor’s Gift is required by law to collect applicable transaction taxes for purchases made in certain tax jurisdictions.</div>

                            <div className="p-4 ">
                                <h5 className="fw-bold mb-3">Payment Method</h5>
                                <Accordion activeKey={activeKey}>
                                    {/* Credit/Debit Card */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className="custom-header">
                                            <div className="payment-header w-100 d-flex justify-content-between align-items-center">
                                                <Form.Check
                                                    type="radio"
                                                    id="card"
                                                    name="payment"
                                                    checked={paymentMethod === 'card'}
                                                    onChange={() => handleSelect('0', 'card')}
                                                    label={
                                                        <div className="d-flex align-items-center payment-label">
                                                            <FaCreditCard className="me-2" /> Credit/Debit Card
                                                        </div>
                                                    }
                                                />

                                                {/* Icons aligned to the right */}
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="payment-icon">
                                                        <img src="/payments/visa_payment_method_card.png" alt="Visa" />
                                                    </div>
                                                    <div className="payment-icon">
                                                        <img src="/payments/master_card_icon.png" alt="MasterCard" />
                                                    </div>
                                                    <div className="payment-icon">
                                                        <img src="/payments/amex_82052.png" alt="Amex" />
                                                    </div>
                                                    <div className="payment-icon">
                                                        <img src="/payments/discover_.png" alt="Discover" />
                                                    </div>
                                                    <div className="payment-icon">
                                                        <img src="/payments/jcb.png" alt="JCB" />
                                                    </div>
                                                </div>

                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Card Number<span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Enter Card Number" value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} />
                                            </Form.Group>
                                            <div className="d-flex gap-3 mb-3">
                                                <div className="w-50">
                                                    <Form.Label>Expire Date <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="MM/YY" value={expireDate} onChange={(e) => setExpireDate(e.target.value)} />
                                                </div>

                                                <div className="w-50">
                                                    <Form.Label>CVC/CVV <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="CVC" value={cvc} onChange={(e) => setCvc(e.target.value)} />
                                                </div>
                                            </div>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Name on Card<span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Name on Card" value={cardName} onChange={(e) => setCardName(e.target.value)} />
                                            </Form.Group>
                                            <Form.Check label="Securely save this card for later purchase" />
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Apple Pay */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header className="custom-header" onClick={() => handleSelect('1', 'apple')}>
                                            <div className="payment-header">
                                                <Form.Check
                                                    type="radio"
                                                    id="apple"
                                                    name="payment"
                                                    checked={paymentMethod === 'apple'}
                                                    onChange={() => handleSelect('1', 'apple')}
                                                    label={
                                                        <span className="d-flex align-items-center payment-label">
                                                            <FaApplePay className="me-2" height="24" /> Apple Pay
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Button className="btn-dark w-100">     <img src="/payments/apple.png" alt="Visa" height="24" />Pay with Apple Pay</Button>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* PayPal */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header className="custom-header" onClick={() => handleSelect('2', 'paypal')}>
                                            <div className="payment-header">
                                                <Form.Check
                                                    type="radio"
                                                    id="paypal"
                                                    name="payment"
                                                    checked={paymentMethod === 'paypal'}
                                                    onChange={() => handleSelect('2', 'paypal')}
                                                    label={
                                                        <span className="d-flex align-items-center payment-label">
                                                            <div style={{ marginRight: '8px' }}>
                                                                <img src="/payments/Paypal.png" alt="Visa" height="24" />
                                                            </div>
                                                            PayPal
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <p>In order to complete your transaction, we will transfer you over to PayPal's secure servers.</p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </Form>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="summary p-5">
                        <h5 className="fw-bold mb-3">Order Summary</h5>
                        <div className="d-flex fw-bold justify-content-between mb-4 ">
                            <span>{featureName}</span>
                            <span>$499</span>
                        </div>
                        <div className="d-flex  fw-bold justify-content-between mb-2">
                            <span>Original Price</span>
                            <span>$3,299</span>
                        </div>
                        {/* <div className="d-flex fw-bold justify-content-between ">
                            <span>Discount (85% OFF):</span>
                            <span>- $2,800</span>
                        </div> */}
                        <hr />
                        <div className="d-flex justify-content-between fw-bold fs-5">
                            <span>Total :</span>
                            <span>$499</span>
                        </div>
                        <div className="terms mt-4">
                            By completing your purchase, you agree to these <span className="terms-link">Terms of Use</span>.
                        </div>
                        <Button
                            type="submit"
                            className="mt-4 w-100"
                            variant="primary"
                            disabled={!isFormValid()}
                            style={{
                                backgroundColor: !isFormValid() ? '#878A99' : '#007bff', // Disabled color or blue
                                borderColor: !isFormValid() ? '#878A99' : '#007bff', // Border color for consistency
                            }}
                            onClick={()=>{setActiveModal(true)}}
                        >
                            Pay $499
                        </Button>

                    </div>
                </div>
            </div>

            {
                activeModal && <PaymentSuccessModal show={activeModal}
                    handleClose={() => setActiveModal(false)} />
            }
        </div>
    );
};

export default CheckoutPage;
